import React from 'react';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { isCsvFile } from '../../lib/informedConsentFile';
import TooltipPreset from '../common/TooltipPreset';
import { BoxedWrapper } from '../BoxedWrapper';
import InformedConsentFilePicker from './InformedConsentFilePicker';
import { IExtendsInformedConsentModal, informedConsentModalActionCreators } from './informedConsentModalReducer';
import InformedConsentWrapper from './InformedConsentWrapper';

const { selectListAction } = informedConsentModalActionCreators;

export default function InformedConsentReportSelect({ dispatchModal, currentTimeframe }: IExtendsInformedConsentModal) {
    return (
        <InformedConsentWrapper currentTimeframe={currentTimeframe}>
            <BoxedWrapper className="section-2">
                <>
                    <div className="mt-5">
                        <h5>
                            Upload Informed Consent <b>.CSV</b> List
                            <TooltipPreset text="Upload a file with all of your clients served in the data period above for which you have signed consent forms. Make sure that your file is exported from Excel as a .CSV file for the Hashing Application to accept it. ">
                                <FontAwesomeIcon className="mt-1 ml-2 file-upload-tooltip" icon={faQuestionCircle} />
                            </TooltipPreset>
                        </h5>
                        <InformedConsentFilePicker
                            accept=".csv"
                            validate={isCsvFile}
                            onSelect={(file) => dispatchModal(selectListAction(file))}
                        />
                    </div>
                </>
            </BoxedWrapper>
        </InformedConsentWrapper>
    );
}
